import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';

import SUTextField from '../../Components/SUTextField';
import NodeEditorChrome from '../../Components/NodeEditorChrome';
import { NODE_THEMES } from '../../Components/NodeTheme';
import TriggerTypeField from '../../Components/TriggerTypeField';
import useNodeEditor from '../../Components/useNodeEditor';

import styledComponent from 'styled-components';
import Select from 'react-select';

import { FaBrain } from 'react-icons/fa';

const ASSISTANT_NODE_COLOR = '#A7ADA7';

const Tags = ({
  selectedNode,
  handleSelectedNode,
  removeNode,
  nodes,
  edges,
  editFlow,
  updateBot,
  truncateText,
  customStyles,
  customStylesDark,
  isDark,
  listAssistants,
  watchSelectedNode,
  valueSelectedVariable,
  typeInputValue,
  typeInput,
  resetVariable,
  contextVariables,
  onMouseDown,
  isDragging,
  isExpanded,
  setIsExpanded,
}) => {
  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
  } = useForm({
    user_response: null,
  });

  const { handleInputChange, loadData, saveNode, getIsDirty } = useNodeEditor({
    selectedNode,
    handleSelectedNode,
    nodes,
    edges,
    editFlow,
    updateBot,
    reset,
    getValues,
  });

  const [errorAssistant, setErrorAssistant] = useState(false);

  // ------> Selects, Radios, Checkbox
  const theme = isDark == 'true' ? NODE_THEMES.dark : NODE_THEMES.light;
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  // FUNCTIONS

  //# Function para manejar cambios de estados de campos

  //# Function para guardar los datos
  const saveData = (values) => {
    if (!selectedNode.data.assistant) {
      setErrorAssistant(true);
      return;
    }

    setLoadingUpdate(true);

    const data = {
      title: values.title,
      user_response: values.user_response,
      bot_response: values.bot_response,
      trigger_type: selectedNode.data?.trigger_type || 'message',
    };

    saveNode(data, () => {
      setLoadingUpdate(false);
    });
  };

  //# Function para obtner data
  const getData = () => {
    let objectData = {
      title: selectedNode.data?.title ?? null,
      user_response: selectedNode.data?.user_response ?? null,
      bot_response: selectedNode.data?.bot_response ?? null,
      trigger_type: selectedNode.data?.trigger_type ?? 'message',
    };
    loadData(objectData);
  };

  useEffect(() => {
    if (typeInput == 'node') {
      setValue(
        typeInputValue,
        getValues(typeInputValue) + valueSelectedVariable
      );
      resetVariable();
    }
  }, [valueSelectedVariable]);

  useEffect(() => {
    getData();
  }, [watchSelectedNode]);

  return (
    <NodeEditorChrome
      icon={FaBrain}
      color={ASSISTANT_NODE_COLOR}
      typeName="Asistente IA"
      title={truncateText(selectedNode.data.title)}
      onRemove={() => removeNode(selectedNode.id)}
      onMouseDown={onMouseDown}
      isDragging={isDragging}
      onClose={() => handleSelectedNode(null)}
      formId="assistantForm"
      saving={loadingUpdate}
      isDark={isDark}
      getIsDirty={getIsDirty}
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
    >
        <form id="assistantForm" onSubmit={handleSubmit(saveData)} style={{ width: '100%' }}>
          <div>
            <div className="col p-0">
              <SUTextField
                id="title"
                name="title"
                label="Título:"
                type="text"
                selectedNode={selectedNode}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                {...register('title', {
                  required: {
                    value: selectedNode.data.first ? false : true,
                    message: 'Campo requerido.',
                  },
                  pattern: {
                    value: /\S+/,
                    message: 'No puede ser solo espacios en blanco',
                  },
                })}
              />
            </div>
            <div className="col p-0 mt-4">
              <label
                htmlFor="assistant"
                style={{ color: theme.textSecondary, fontWeight: 600 }}
              >
                Asistente:{' '}
              </label>
              <div className="su-control-group d-flex">
                <Select
                  styles={isDark == 'true' ? customStylesDark : customStyles}
                  className="form-control basic-multi-select"
                  placeholder="Seleccione..."
                  name="assistants"
                  value={selectedNode.data.assistant || ''}
                  onChange={(assis) => {
                    handleInputChange('assistant', assis);
                    setErrorAssistant(false);
                  }}
                  options={listAssistants}
                  classNamePrefix="select"
                  noOptionsMessage={() => 'Sin opciones'}
                  getOptionLabel={(option) => (
                    <div className="option d-flex" style={{ fontSize: '15px' }}>
                      {option.name}
                    </div>
                  )}
                  getOptionValue={(option) => option.name}
                />
              </div>
              {errorAssistant && <Alert>* Campo requerido</Alert>}
            </div>
            {!selectedNode.data?.first && (<>
            <div className="col p-0 mt-4">
              <TriggerTypeField
                value={selectedNode.data?.trigger_type}
                handleInputChange={handleInputChange}
                isDark={isDark}
                customStyles={customStyles}
                customStylesDark={customStylesDark}
              />
            </div>
            <div className="col p-0 mt-4">
              <SUTextField
                id="user_response"
                name="user_response"
                label="Respuesta del cliente:"
                hint="Lo que debe llegar para activar este nodo: el texto que escribe el cliente, el título de un botón, o * para cualquier respuesta. Para varios, separalos con  /  ."
                type="textArea"
                selectedNode={selectedNode}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                {...register('user_response', {
                  required: {
                    value: true,
                    message: 'Campo requerido.',
                  },
                  pattern: {
                    value: /\S+/,
                    message: 'No puede ser solo espacios en blanco',
                  },
                })}
              />
            </div>
            </>)}
            <div className="col p-0 mt-4">
              <SUTextField
                id="bot_response"
                name="bot_response"
                label="Respuesta del Bot (opcional):"
                maxLength={4096}
                hint="Mensaje que se envía antes de que responda el asistente. Si lo dejas vacío, responde solo el asistente."
                placeholder="Escribe la respuesta del Bot"
                type="textArea"
                showEmoji
                showSticker
                showVariables
                selectedNode={selectedNode}
                contextVariables={contextVariables}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                {...register('bot_response', {
                  validate: (value) =>
                    !value ||
                    String(value).trim() !== '' ||
                    'No puede ser solo espacios en blanco',
                })}
              />
            </div>
          </div>
        </form>
    </NodeEditorChrome>
  );
};

export default Tags;

const Alert = styledComponent.span`
  color: red;
  display: block;
  width: 100%;
  // width: 200px;
`;
